import './onboardScrutinizers.css';
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

import { SAVE_INTERNAL_STAKEHOLDER, All_ONBOARD_STAKEHOLDER_ROLE, ALL_MODULE_ROLES } from '../../../common/URLs';
import { GENDER, GOV_ID_LIST_USER, SALUTATION, BLOCK_LIST, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE } from '../../../common/constants';
import { Container, Card, Checkbox, Link, CardContent, IconButton, Button, Tab, Stack, Box, Typography, Grid, FormControl, FormControlLabel, FormGroup, InputLabel, Select, MenuItem, TextField, Tooltip } from '@mui/material';
import resolveIcon from "../../../images/resolved.png";
import { sendOTP, validateOTP } from '../../../common/Utils';
import { MOBILE_NO_ERROR, INVALID_OTP_ERROR, ROLES } from '../../../common/constants';
import { GET_ADDRESS_BY_PINCODE, authKey, GET_ALL_USERS, GET_USER } from '../../../common/URLs';
import { loaderService } from '../../../common/custom-loader/loader-service';
import DeleteIcon from '@mui/icons-material/Delete';
import { nameValidation } from "../../../common/commonValidations";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { PROD } from '../../../common/constants';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { Add as AddIcon } from '@mui/icons-material';
import { VALIDATION } from "../../../common/commonValidations";
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import apiClient from '../../../axios';

const OnboardingScrutinizers = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const shoullog = useRef(true);
    const [userId, setUserId] = useState()
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [otpValue, setOtpValue] = useState()
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
    const [personalRevenueCircleBlocklistLabel, setPersonalRevenueCircleBlocklistLabel] = useState(REVENUE_BLOCK_DEFAULT_VALUE);
    const [personalRevenueCircleAndBlockList, setPersonalRevenueCircleAndBlockList] = useState([]);
    const [showGrid, setShowGrid] = useState(true);
    const [showForm, setShowForm] = useState('');
    const [userDetails, setUserDetails] = useState([]);
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [id, setId] = useState('');
    const [salutation, setSalutation] = useState('');
    const [gender, setGender] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [emailId, setEmailId] = useState('');
    const [address, setAddress] = useState('');
    const [pincode, setPincode] = useState('');
    const [state, setState] = useState('');
    const [district, setDistrict] = useState('');
    const [govCardIdNo, setGovCardIdNo] = useState('');
    const [govCardIdType, setGovCardIdType] = useState('Aadhaar ID');
    const [details, setDetails] = useState({
        Salutation: 'Mr',
        Firstname: '',
        Middlename: '',
        Lastname: '',
        mobileNo: '',
        Gender: 'Male',
        email: '',
        address: '',
        pincode: '',
        OnBoardGovtIdType: 'Aadhaar ID',
        govtIdProofNumber: '',
        id: '',
        selectedPersonalRevenueCircle: '',
        selectedPersonalBlockList: '',
        state: '',
        district: ''
    });
    const [userDetail, setUserDetail] = useState({
        Salutation: 'Mr',
        Firstname: '',
        Middlename: '',
        Lastname: '',
        mobileNo: '',
        Gender: 'Male',
        email: '',
        address: '',
        pincode: '',
        OnBoardGovtIdType: 'Aadhaar ID',
        govtIdProofNumber: '',
        id: '',
        selectedPersonalRevenueCircle: '',
        selectedPersonalBlockList: '',
        state: '',
        district: ''
    });
    const [onboardStakeHolderRoleDetails, setonboardStakeHolderRoleDetails] = useState();
    const [saveUserDetails, setSaveUserDetails] = useState();

    let [RoleDetails, setRoleDetails] = useState([]);
    let [RoleDetailsDisplay, setRoleDetailsDisplay] = useState([]);
    let [userRoles, setuserRoles] = useState([]);
    let [userRolesEdit, setuserRolesEdit] = useState([]);
    let [userRolesUpdate, setuserRolesUpdate] = useState([]);
    const [errorMessage, setErrorMessage] = useState({
        fullNameError: '',
        contactPersonNameError: '',
        contactPersonMiddleNameError: '',
        contactPersonLastNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        emailIdError: '',
        addressError: '',
        govtIdCardNumberError: '',
        govtIdNoErr: '',
        govtIdTypeErr: '',
        roleError: '',
    });
    const [disabledval, setDisabledval] = useState(false);
    const [checkedval, setCheckedval] = useState(false);
    const [usersToBeDeleted, setUsersToBeDeleted] = useState([]);
    const [userApiData, setUserApiData] = useState();
    const [selected, setSelected] = useState();
    const [logModalOpen3, setLogModalOpen3] = useState(false);
    const handleLogModalClose3 = () => setLogModalOpen3(false);
    const handleLogModalOpen3 = () => setLogModalOpen3(true);

    const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
    const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
    const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);

    const [roles, setRoles] = useState();
    const requiredRoles = [ROLES.RegAssistant, ROLES.RegistrationScruitnizer, ROLES.LeadRegScrutinizer]

    useEffect(() => {
        getAllModuleRoles();
    }, [])

    const checkBoxHandleChange = (parentIndex, childIndex, checkedValue) => {
        const updatedData = [...roles]
        updatedData[parentIndex].RolesDetails[childIndex].checked = !checkedValue
        setRoles(updatedData)
    }

    function getAllModuleRoles() {
        apiClient
            .post(ALL_MODULE_ROLES,
                {
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setRoles(response.data.lstModulesWithRolesMaster?.filter((filterItem) => filterItem.parentModuleName === "Registration").map((item) => ({
                    moduleName: item?.parentModuleName,
                    RolesDetails: item?.childRolesName.filter((rolesFilter) => requiredRoles.includes(rolesFilter.childRolesName)).map((child) => ({
                        ...child,
                        checked: false, // Add the 'checked' property with an initial value
                    })),
                })))
            })
            .catch(function (error) {
            });
    }

    useEffect(() => {
        if (userDetail) {
            setId(userDetail?.id)
            setSalutation(userDetail?.salutation)
            setFirstName(userDetail?.firstname)
            setLastName(userDetail?.lastname)
            setMiddleName(userDetail?.middlename)
            setMobileNumber(userDetail?.mobileNo)
            setGender(userDetail?.gender)
            setEmailId(userDetail?.emailAddress)
            setGovCardIdType(userDetail?.govtIdProofType)
            setGovCardIdNo(userDetail?.govtIdProofNumber)
            setAddress(userDetail?.address)
            setPincode(userDetail?.pincode)
            setState(userDetail?.state)
            setDistrict(userDetail?.district)
            setuserRolesEdit(userDetail?.userRoles)

            RoleDetails.map(item1 => {
                if (userDetail?.userRoles?.filter(item => item.roleId === item1.id).length > 0) {
                    item1.checked = true;
                    // item1.disabled= false;
                }
                else {
                    item1.checked = false;
                    // item1.disabled= true;
                }
            }
            );
            setRoleDetailsDisplay(RoleDetails);
        }

    }, [userDetail]);
    useEffect(() => {
        if (userId) {
            getUserDetails();
        }
    }, [userId]);

    function getUserDetails() {
        apiClient
            .post(GET_USER,
                {
                    "userID": userId

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetail(response.data.user);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {

        if (shoullog.current) {
            shoullog.current = false;
            gellAllOnboardedRole();
        }
        if (saveUserDetails) {
            if (!(saveUserDetails.user)) {
                toast.error(saveUserDetails?.message);
            }
            else {
                toast.success(saveUserDetails?.message);
                setShowGrid(true);
                setShowForm('');
                getAllUserDetails();
            }
        }

    }, [saveUserDetails]);
    const confirmDelete = (e, selected) => {
        e.preventDefault();
        setSelected(selected);
        handleLogModalOpen3();

    }
    function gellAllOnboardedRole() {

        apiClient
            .post(All_ONBOARD_STAKEHOLDER_ROLE,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setonboardStakeHolderRoleDetails(response.data);

            })
            .catch(function (error) {
            });
    }

    const confirmSubmission = (e) => {
        e.preventDefault();
        if (!details.Firstname) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter your First Name." });
            return;
        }
        else if (!nameValidation(details.Firstname)) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: "Please provide valid Name" });
            return;
        }
        else {
            setErrorMessage({ ...errorMessage, contactPersonNameError: "" });
        }
        const phone_regex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        if (!(details.mobileNo.match(phone_regex))) {
            if (details.mobileNo.length >= 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "" });
            }
            else {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit number" });
                return;

            }
        }
        if (details.mobileNo.length >= 10 && !(otpValue)) {
            if (mobileOTPValidated === true) {
                setErrorMessage({ ...errorMessage, mobileNoError: "" });
            }
            else {
                setErrorMessage({ ...errorMessage, mobileNoError: "Please verify the mobile number" });
                return;
            }
        }
        if (!details.govtIdProofNumber) {
            setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Please enter Id Number" });
            return;
        }
        if (!details.OnBoardGovtIdType) {
            setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Select your ID Proof Type" });
            return;
        }
        const email_regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        if (!(details.email.match(email_regex))) {
            if (!details.email) {
                setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" });
                return;
            }
            else {
                setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" });
                return;
            }
        }
        const selectedRoles = roles
            ?.flatMap((parent) => parent.RolesDetails)
            ?.filter((child) => child.checked);
        if (!selectedRoles || selectedRoles.length == 0) {
            setErrorMessage({ ...errorMessage, roleError: "Please select roles" });
            return;
        }
        else {
            setErrorMessage({ ...errorMessage, roleError: "" });
        }
        handleLogModalConfirmOpen();

    }

    const OnboardedRollMessage = onboardStakeHolderRoleDetails?.message;
    const rolesArray = onboardStakeHolderRoleDetails?.roles;
    const Leadroles = ((rolesArray)?.filter(item => item.roleName === ROLES.LeadRegScrutinizer));
    const scrutinizerroles = ((rolesArray)?.filter(item => item.roleName === ROLES.RegistrationScruitnizer));
    const reg_assistantroles = ((rolesArray)?.filter(item => item.roleName === ROLES.RegAssistant));
    if (OnboardedRollMessage === "Success") {
        if (RoleDetails.length === 0) {
            const OnboardedRoll = onboardStakeHolderRoleDetails?.roles;
            Leadroles.map(item => {

                RoleDetails.push(
                    {
                        id: item?.id,
                        rollName: item?.roleName,
                        checked: false,
                        // disabled:false,
                    }
                );

            });
            scrutinizerroles.map(item => {

                RoleDetails.push(
                    {
                        id: item?.id,
                        rollName: item?.roleName,
                        checked: false,
                        disabled: false,
                    }
                );

            });
            reg_assistantroles.map(item => {
                RoleDetails.push(
                    {
                        id: item?.id,
                        rollName: item?.roleName,
                        checked: false,
                        disabled: false,
                    }
                );

            });
        }
    }
    useEffect(() => {
        setState(pincodeAddressDetails?.addresses[0] ? pincodeAddressDetails?.addresses[0]?.state : state)
        setDistrict(pincodeAddressDetails?.addresses[0] ? pincodeAddressDetails?.addresses[0]?.district : district)

    }, [pincodeAddressDetails]);
    const getPincodeAddressDetails = () => {
        if ((details.pincode).length != 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
        }
        else {
            loaderService.showLoader()
            setErrorMessage({ ...errorMessage, pincodeError: "" });
            setErrorMessage({ ...errorMessage, searchError: "" });
            apiClient
                .post(GET_ADDRESS_BY_PINCODE,
                    {
                        "pincode": details.pincode,
                    },
                    {
                        headers: {
                            AuthKey: authKey,
                        },
                    }
                )
                .then((response) => {
                    setPincodeAddressDetails(response.data);
                    loaderService.hideLoader()
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader()

                });
        }
    }
    const getPincodeAddressDetailsUpdate = () => {
        if ((pincode).length != 6) {
            setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
        }

        else {
            loaderService.showLoader()
            setErrorMessage({ ...errorMessage, pincodeError: "" });
            setErrorMessage({ ...errorMessage, searchError: "" });
            apiClient
                .post(GET_ADDRESS_BY_PINCODE,
                    {
                        "pincode": pincode,
                    },
                    {
                        headers: {
                            AuthKey: authKey,
                        },
                    }
                )
                .then((response) => {
                    setPincodeAddressDetails(response.data);
                    loaderService.hideLoader()
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader()

                });
        }
    }
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const getUserRolesList = () => {
        setuserRoles([]);
        RoleDetails.forEach((item, index) => {
            if (item.checked === true) {
                userRoles.push({

                    roleId: item.id,
                    rollName: null,
                })
            }

        });

    }
    const getUserRolesListUpdate = () => {
        setuserRolesUpdate([]);
        RoleDetails.forEach((item, index) => {
            if (item.checked === true) {
                userRolesUpdate.push({

                    roleId: item.id,
                    rollName: null,
                })
            }

        });

    }
    useEffect(() => {
        if (RoleDetails) {
            setRoleDetailsDisplay(RoleDetails);
        }
    }, []);
    const handleChange = (e) => {
        setDetails({ ...details, [e.target.name]: e.target.value })
        if (e.target.name === "address") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else {
                setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })

            }
        }
        if (e.target.name === "email") {
            if ((e.target.value).length > 0) {
                if (isValidEmail(e.target.value)) {
                    setDetails({ ...details, [e.target.name]: e.target.value })
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
        }
        if (e.target.name === "Firstname") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0 && nameValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
            } else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter First Name" })

            }
        }
        if (e.target.name === "Middlename") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
        }
        if (e.target.name === "Lastname") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })

        }
        if (e.target.name === "mobileNo") {
            const limit = 10;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length >= 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: "" });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit number" });


        }
        if (e.target.name === "govtIdProofNumber") {
            const limit = 4;
            const idlimit = 20
            if (details.OnBoardGovtIdType === "Aadhaar ID") {
                setDetails({ ...details, [e.target.name]: e.target.value.replace(/[^0-9]/gi, '').slice(0, limit) })
                if ((e.target.value).length >= 4) {
                    setErrorMessage({ ...errorMessage, govtIdCardNumberError: '' })
                }
                else {
                    setErrorMessage({ ...errorMessage, govtIdCardNumberError: 'Enter last 4 digits of Aadhaar Id' })
                }
            }
            else {
                setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, idlimit)) })
                if ((e.target.value).length > 0) {
                    setErrorMessage({ ...errorMessage, govtIdCardNumberError: '' })
                }
                else {
                    setErrorMessage({ ...errorMessage, govtIdCardNumberError: 'Please enter ID Number' })
                }
            }


        }
        if (e.target.name === "pincode") {
            const limit = 6;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            if ((e.target.value).length < 6) {
                setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
    }
    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }
    const callBackMobileValidation = (response) => {
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "" })
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
            setVerifyMobileNo(true);
            setOtpHidden(false);
            setErrorMessage({ ...errorMessage, OTPError: "" });
        }

    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "" });
        setErrorMessage({ ...errorMessage, mobileNoError: "" });
        if (response.isSuccess === true) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setErrorMessage({ ...errorMessage, mobileNoError: "" });
        }
        else {
            setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
        }
    }
    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }
    function updateABRPLUser() {
        apiClient
            .post(SAVE_INTERNAL_STAKEHOLDER,
                {
                    "abrplUser": {
                        "id": details?.id,
                        "salutation": details.Salutation ? details.Salutation : 'Mr',
                        "gender": details.Gender ? details.Gender : 'Male',
                        "firstname": details.Firstname,
                        "middlename": details.Middlename,
                        "lastname": details.Lastname,
                        "address": details.address,
                        "pincode": details.pincode,
                        "state": pincodeAddressDetails?.addresses[0]?.state,
                        "district": pincodeAddressDetails?.addresses[0]?.district,
                        "govtIdProofType": details.OnBoardGovtIdType,
                        "govtIdProofNumber": details.govtIdProofNumber,
                        "mobileNo": details.mobileNo,
                        "emailAddress": details.email,
                        "isActive": 1,
                        "userRoles": roles
                            ?.flatMap((parent) => parent.RolesDetails)
                            ?.filter((child) => child.checked)
                            ?.map((child) => ({ roleID: child.roleId, roleName: child.childRolesName }))
                    },
                    "loginUserRole": getLocalStorageItem('role'),
                    "loginUserID": getLocalStorageItem('uuid') ? getLocalStorageItem('uuid') : ''
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                }
                setSaveUserDetails(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    function addABRPLUser() {
        apiClient
            .post(SAVE_INTERNAL_STAKEHOLDER,
                {
                    "abrplUser": {
                        "salutation": details.Salutation ? details.Salutation : 'Mr',
                        "gender": details.Gender ? details.Gender : 'Male',
                        "firstname": details.Firstname,
                        "middlename": details.Middlename,
                        "lastname": details.Lastname,
                        "address": details.address,
                        "pincode": details.pincode,
                        "state": pincodeAddressDetails?.addresses[0]?.state,
                        "district": pincodeAddressDetails?.addresses[0]?.district,
                        "govtIdProofType": details.OnBoardGovtIdType,
                        "govtIdProofNumber": details.govtIdProofNumber,
                        "mobileNo": details.mobileNo,
                        "emailAddress": details.email,
                        "isActive": 1,
                        "userRoles": roles
                            ?.flatMap((parent) => parent.RolesDetails)
                            ?.filter((child) => child.checked)
                            ?.map((child) => ({ roleID: child.roleId, roleName: child.childRolesName }))
                    },
                    "loginUserRole": getLocalStorageItem('role'),
                    "loginUserID": getLocalStorageItem('uuid') ? getLocalStorageItem('uuid') : ''
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                }
                setSaveUserDetails(response.data);

            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onPrevious = (e) => {
        e.preventDefault();
        setShowGrid(true);
        setShowForm('');
        roles.forEach((parent) => {
            parent.RolesDetails.forEach((child) => {
                child.checked = false; // Set the 'checked' property to false

            });
        });
    }
    const onSubmit = () => {
        handleLogModalConfirmClose();
        if ((details.Firstname) && (details.mobileNo) && (otpValue) && (details.email) && (details.OnBoardGovtIdType) && (details.govtIdProofNumber) && (errorMessage.emailIdError.length == 0) && (errorMessage.mobileNoError.length == 0) && (errorMessage.govtIdCardNumberError.length == 0) && (errorMessage.contactPersonNameError.length == 0)) {
            getUserRolesList();
            addABRPLUser();
        }
    }
    const onSubmitUpdate = () => {
        handleLogModalConfirmClose();
        if ((details.Firstname) && (details.mobileNo) && (details.email) && (details.OnBoardGovtIdType) && (details.govtIdProofNumber) && (errorMessage.emailIdError.length == 0) && (errorMessage.mobileNoError.length == 0) && (errorMessage.govtIdCardNumberError.length == 0) && (errorMessage.contactPersonNameError.length == 0)) {
            getUserRolesListUpdate();
            updateABRPLUser();
        }
    }
    useEffect(() => {
        getAllUserDetails();
    }, []);


    function getAllUserDetails() {
        apiClient
            .post(GET_ALL_USERS,
                {

                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data.users);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const addnewBtnClick = (e) => {
        e.preventDefault();
        setShowGrid(false);
        setShowForm('Add');
        setDetails({
            Salutation: 'Mr',
            Firstname: '',
            Middlename: '',
            Lastname: '',
            mobileNo: '',
            Gender: 'Male',
            email: '',
            address: '',
            pincode: '',
            OnBoardGovtIdType: 'Aadhaar ID',
            govtIdProofNumber: '',
            id: '',
            selectedPersonalRevenueCircle: '',
            selectedPersonalBlockList: '',
            state: '',
            district: ''
        });
        setErrorMessage({
            fullNameError: '',
            contactPersonNameError: '',
            contactPersonMiddleNameError: '',
            contactPersonLastNameError: '',
            mobileNoError: '',
            pincodeError: '',
            searchError: '',
            emailIdError: '',
            addressError: '',
            govtIdCardNumberError: '',
            govtIdNoErr: '',
            govtIdTypeErr: '',
        });
        setPincodeAddressDetails(null);
        setCheckedval(false);
        setDisabledval(false);
        setVerifyMobileNo(false);
        setMobileOTPValidated(false);
        setOtpValue();
        roles.forEach((parent) => {
            parent.RolesDetails.forEach((child) => {
                child.checked = false; // Set the 'checked' property to false

            });
        });
    }
    const editBtnUserClick = (e, item) => {
        e.preventDefault();
        setUserId(item.id);
        setShowGrid(false);
        setShowForm('Edit');
        setMobileOTPValidated(true);
        setDetails({
            Salutation: item?.salutation,
            Firstname: item?.firstname,
            Middlename: item?.middlename,
            Lastname: item?.lastname,
            mobileNo: item?.mobileNo,
            Gender: item?.gender,
            email: item?.emailAddress,
            address: item?.address,
            pincode: item?.pincode,
            OnBoardGovtIdType: item?.govtIdProofType,
            govtIdProofNumber: item?.govtIdProofNumber,
            id: item?.id,
            selectedPersonalRevenueCircle: '',
            selectedPersonalBlockList: '',
            state: item?.state,
            district: item?.district,
        })
        item?.userRoles.forEach((obj) => {
            roles.forEach((parent) => {
                parent.RolesDetails.forEach((child) => {
                    if (child.roleId === obj.roleId) {
                        child.checked = true; // Set the 'checked' property to true
                    }
                });
            });
        });
    }
    const onDeleteUser = () => {
        setLogModalOpen3(false)
        const tempdata = userDetails.filter((item) => !(item.id === selected.id))
        const deleteData = userDetails.filter((item) => item.id === selected.id)
        setUserDetails(tempdata)
        setUsersToBeDeleted(deleteData)

        const arr = [...usersToBeDeleted, ...deleteData]

        const dataForApi = arr.map((item) => (
            {
                id: item.id,
                salutation: item.salutation,
                gender: item.gender,
                firstname: item.firstname,
                middlename: item.middlename,
                lastname: item.lastname,
                address: item.address,
                pincode: item.pincode,
                state: item.state,
                district: item.district,
                govtIdProofType: item.govtIdProofType,
                govtIdProofNumber: item.govtIdProofNumber,
                mobileNo: item.mobileNo,
                emailAddress: item.emailAddress,
                isActive: 0,
                userRoles: roles
                    ?.flatMap((parent) => parent.RolesDetails)
                    ?.filter((child) => child.checked)
                    ?.map((child) => child.childRolesName)

            }))
        setUserApiData(dataForApi)
        deleteUserApi(dataForApi);
    };
    const onSubmitApi = (dataForApi) => {
        deleteUserApi(dataForApi);
    }

    const deleteUserApi = (dataForApi) => {
        apiClient
            .post(SAVE_INTERNAL_STAKEHOLDER,
                {
                    "abrplUser": dataForApi?.[0],
                    "loginUserRole": getLocalStorageItem('role'),
                    "loginUserID": getLocalStorageItem('uuid') ? getLocalStorageItem('uuid') : ''
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                setSaveUserDetails(response.data);
            })
            .catch(function (error) {
                console.log(error);

            });
    }
    const userDetailsList = userDetails?.filter((item1) => item1.isActive === 1 && item1?.userRoles?.[0]?.roleName === ROLES.LeadRegScrutinizer || item1?.userRoles?.[0]?.roleName === ROLES.RegistrationScruitnizer || item1?.userRoles?.[0]?.roleName === ROLES.RegAssistant)

    const columns = [
        {
            field: 'id', headerName: 'S.No', width: 60,
            renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
        },
        {
            field: 'firstname', headerName: t('preReg.name'), width: 200,
            valueGetter: (params) => {

                if (params) {

                    return params.row.firstname + " " + params.row.middlename + " " + params.row.lastname

                } else return '-'

            }
        },
        {
            field: 'roleName', headerName: 'Role', width: 200,
            valueGetter: (params) => {
                return params.row?.userRoles?.[0]?.roleName;
            },
            // renderCell: (params) => {
            //     const { firstName, lastName } = params.value;
            //     return <div>{`${firstName} ${lastName}`}</div>;
            //     },
        },
        {
            field: 'delete', headerName: 'Delete', width: 200,
            renderCell: (params) => {
                return (
                    <Tooltip title="Delete">
                        <IconButton size='small' className='icon_button_grower_pre_reg' color="primary" aria-label="search"
                            onClick={(e) => confirmDelete(e, params?.row)} >
                            <DeleteIcon color='error' fontSize='small' />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
        {
            field: 'edit', headerName: 'Edit', width: 200,
            renderCell: (params) => {
                return (
                    <Button onClick={(e) => editBtnUserClick(e, params?.row)}>Edit</Button>
                );
            }
        }
    ];

    return (

        <>
            {showGrid === true ?
                <Container fluid>
                    {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG65</p>}
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-start" mb={1}>
                        <Button variant='contained' style={{ marginTop: "2vh", alignContent: "end" }} onClick={(e) => addnewBtnClick(e)} startIcon={<AddIcon />}>Add New User</Button>
                    </Stack>
                    {userDetails && userDetails?.filter((item1) => item1.isActive === 1 && item1?.userRoles?.[0]?.roleName === ROLES.LeadRegScrutinizer || item1?.userRoles?.[0]?.roleName === ROLES.RegistrationScruitnizer || item1?.userRoles?.[0]?.roleName === ROLES.RegAssistant) ?
                        <Box style={{ height: 500, width: '100%' }}>
                            <DataGrid
                                rows={userDetailsList}
                                columns={columns}
                                pageSize={10}
                                getRowId={(row) => row?.id}
                                components={{ Toolbar: QuickSearchToolbar }}
                            />
                        </Box> : null}
                </Container>
                : null}
            {showForm ?
                <Container maxWidth="xxl">
                    {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>REG57</p>}
                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                        {/* <BackButton navigate={navigate} navigateTo="/registrationHome/onboarding"/> */}
                        <Typography variant="h5" gutterBottom>
                            General User Information
                        </Typography>
                    </Stack>
                    <Card>
                        <CardContent>
                            <Grid container spacing={4} direction="row">
                                <Grid item xs={12} lg={6}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth>
                                                <InputLabel>Salutation</InputLabel>
                                                <Select name="Salutation" label="Salutation" value={details.Salutation} onChange={(e) => handleChange(e)}>
                                                    {SALUTATION.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.contactPersonNameError}
                                                helperText={errorMessage.contactPersonNameError}
                                                type="text"
                                                label="First Name"
                                                name="Firstname"
                                                value={details.Firstname}
                                                onChange={(e) => handleChange(e)}
                                                autoComplete="off"
                                                inputProps={{
                                                    maxLength: "20"
                                                }} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField fullWidth
                                                type="text"
                                                label="Middle Name"
                                                name="Middlename"
                                                value={details.Middlename}
                                                onChange={(e) => handleChange(e)}
                                                autoComplete="off"
                                                inputProps={{
                                                    maxLength: "20"
                                                }} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField fullWidth
                                                type="text"
                                                label="Last Name"
                                                name="Lastname"
                                                value={details.Lastname}
                                                onChange={(e) => handleChange(e)}
                                                autoComplete="off"
                                                inputProps={{
                                                    maxLength: "20"
                                                }} />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth required>
                                                <InputLabel>Gender</InputLabel>
                                                <Select name="Gender" label="Gender" value={details.Gender} onChange={(e) => handleChange(e)}
                                                >{GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={verifyMobileNo ? 5 : 8}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.mobileNoError}
                                                helperText={errorMessage.mobileNoError}
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                label="Mobile No."
                                                name="mobileNo"
                                                value={details.mobileNo}
                                                onChange={(e) => handleChange(e)}
                                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                                disabled={showForm === "Edit" || mobileOTPValidated} />
                                        </Grid>
                                        {verifyMobileNo &&
                                            <Grid item xs={3}>
                                                <TextField
                                                    type="number"
                                                    onFocus={handleNumberFieldFocus}
                                                    onChange={(e) => onOtpChange(e)}
                                                    value={otpValue}
                                                    label="Enter OTP"
                                                    onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                            </Grid>}
                                        <Grid item xs={12}>
                                            {verifyMobileNo === true ?
                                                <div>
                                                    <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                                                : mobileOTPValidated === true ? <div hidden={!mobileOTPValidated} className='commonVerifyText'><a href="#">Verified</a>
                                                    <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :
                                                    <button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>
                                            }
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth required>
                                                <InputLabel>ID Proof</InputLabel>
                                                <Select
                                                    name="OnBoardGovtIdType"
                                                    value={details.OnBoardGovtIdType}
                                                    onChange={(e) => handleChange(e)}
                                                    label='ID Proof'>
                                                    {GOV_ID_LIST_USER.map((item) => <MenuItem value={item}> {item}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <TextField fullWidth required
                                                error={errorMessage.govtIdCardNumberError}
                                                helperText={errorMessage.govtIdCardNumberError}
                                                type={details.OnBoardGovtIdType === "Aadhaar ID" ? "number" : "text"}
                                                name="govtIdProofNumber"
                                                value={details.govtIdProofNumber}
                                                onChange={(e) => handleChange(e)}
                                                autoComplete="off"
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                label={details.OnBoardGovtIdType === "Aadhaar ID" ? "Enter last 4 digits" : details.OnBoardGovtIdType === "Voter ID" ? "Enter Voter ID No" : details.OnBoardGovtIdType === "Driving Licence" ? "Enter Driving Licence No" : details.OnBoardGovtIdType === "Internal Employee ID" ? "Enter Internal Employee ID" : "Enter Bank Passbook No"}
                                                onKeyDown={(evt) => (details.OnBoardGovtIdType === "Aadhaar ID" ? evt.key === 'E' || evt.key === 'e' || evt.key === '.' || evt.key === '-' || evt.key === '+' : evt.key === '=' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField fullWidth required
                                                error={errorMessage.emailIdError}
                                                helperText={errorMessage.emailIdError}
                                                type="text"
                                                label="Email address"
                                                disabled={showForm === 'Edit'} c
                                                name="email"
                                                value={details.email}
                                                onChange={(e) => handleChange(e)} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <span className="mandatory_field">{errorMessage.roleError}</span>
                                    <Typography variant='h6'>Roles</Typography>
                                    <div>
                                        {roles?.map((item, parentIndex) => {
                                            return (
                                                <>
                                                    <Typography variant='h6' style={{ fontSize: "15px", marginTop: "4px" }}>{item?.moduleName}</Typography>
                                                    <FormGroup>
                                                        {item.RolesDetails.map((roleItem, childIndex) => {
                                                            return (
                                                                <FormControlLabel control={<Checkbox checked={roleItem.checked} onChange={() => checkBoxHandleChange(parentIndex, childIndex, roleItem?.checked)} />} label={roleItem?.childRolesName} />
                                                            )
                                                        })}
                                                    </FormGroup>
                                                </>
                                            )
                                        })}
                                    </div>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                        <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onPrevious(e)} >Cancel</Button>
                        {
                            showForm === "Edit" ? <Button variant="contained" sx={{ minWidth: 100, ml: "1vh" }} onClick={(e) => confirmSubmission(e)} >Update </Button> : <Button variant='contained' sx={{ minWidth: 100, ml: "1vh" }} onClick={(e) => confirmSubmission(e)}>Submit</Button>}
                    </Box></Container> : null}
            <ConfirmationPopover onOpen={logModalOpen3} onConfirm={onDeleteUser} action="Delete" onClose={handleLogModalClose3} />
            <ConfirmationPopover onOpen={logModalOpenConfirm} action={showForm === 'Edit' ? "Update" : "Submit"} onConfirm={showForm === 'Edit' ? onSubmitUpdate : onSubmit} onClose={handleLogModalConfirmClose} />

        </>
    )
}
export default OnboardingScrutinizers;
